/* Jewish Swag Shop — theme JS (progressive enhancement) */
(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll reveal ---- */
  function initReveal(){
    var els = document.querySelectorAll('[data-reveal]:not(.is-in)');
    if(reduce){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold:.12, rootMargin:'0px 0px -6% 0px' });
    els.forEach(function(e){ io.observe(e); });
  }

  /* ---- hero word rotor (CSS handles transform; we just sync count) ---- */
  function initRotor(){
    document.querySelectorAll('[data-rotor]').forEach(function(r){
      if(reduce){ r.style.animation='none'; }
    });
  }

  /* ---- mega menu ---- */
  function initMenu(){
    var toggle = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-menu-panel]');
    if(!toggle||!panel) return;
    function set(open){ panel.toggleAttribute('hidden', !open); toggle.setAttribute('aria-expanded', open); }
    toggle.addEventListener('click', function(){ set(panel.hasAttribute('hidden')); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') set(false); });
  }

  /* ---- size guide modal ---- */
  function initModals(){
    document.querySelectorAll('[data-modal-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var m = document.getElementById(btn.getAttribute('data-modal-open'));
        if(m) m.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-modal]').forEach(function(m){
      m.addEventListener('click', function(e){ if(e.target===m || e.target.hasAttribute('data-modal-close')) m.classList.remove('is-open'); });
    });
  }

  /* ---- gift note toggle (just reveals helper text) ---- */
  function initGift(){
    var cb = document.querySelector('[data-gift]');
    if(cb){ cb.addEventListener('change', function(){ var n=document.querySelector('[data-gift-note]'); if(n) n.hidden=!cb.checked; }); }
  }

  /* ---- quantity steppers ---- */
  function initQty(){
    document.querySelectorAll('[data-qty]').forEach(function(wrap){
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          var v = parseInt(input.value,10)||1;
          v += b.getAttribute('data-step')==='up' ? 1 : -1;
          input.value = Math.max(parseInt(input.min,10)||1, v);
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    });
  }

  /* ---- AJAX add to cart + drawer ---- */
  var drawer = document.querySelector('[data-cart-drawer]');
  function openDrawer(){ if(drawer) drawer.classList.add('is-open'); }
  function closeDrawer(){ if(drawer) drawer.classList.remove('is-open'); }
  function money(c){ return '$' + (c/100).toFixed(2).replace(/\.00$/,''); }

  function refreshDrawer(){
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart);
  }
  function renderCart(cart){
    if(!drawer) return;
    var body = drawer.querySelector('[data-cart-items]');
    var sub = drawer.querySelector('[data-cart-subtotal]');
    var count = document.querySelectorAll('[data-cart-count]');
    var prog = drawer.querySelector('[data-ship-fill]');
    var msg = drawer.querySelector('[data-ship-msg]');
    if(count) count.forEach(function(c){ c.textContent = cart.item_count; });
    if(sub) sub.textContent = money(cart.total_price);
    if(body){
      body.innerHTML = cart.items.map(function(it){
        return '<div class="cart-line"><div class="cart-line__img"><img src="'+ (it.image? it.image : '') +'" alt=""></div>'+
          '<div class="cart-line__info"><div class="cart-line__title">'+it.product_title+'</div>'+
          '<div class="cart-line__variant">'+(it.variant_title||'')+' &middot; Qty '+it.quantity+'</div></div>'+
          '<div class="cart-line__price">'+money(it.final_line_price)+'</div></div>';
      }).join('') || '<p style="padding:20px;color:var(--muted)">Your cart is empty.</p>';
    }
    if(prog && window.JSS){
      var pct = Math.min(100, Math.round(cart.total_price / window.JSS.freeShip * 100));
      prog.style.width = pct + '%';
      var remain = Math.max(0, window.JSS.freeShip - cart.total_price);
      if(msg) msg.innerHTML = remain>0 ? "You're <b>"+money(remain)+"</b> away from free shipping" : "You\u2019ve unlocked free shipping \u2713";
    }
  }
  function initCart(){
    document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(function(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if(btn){ btn.setAttribute('disabled',''); }
        fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(serialize(form)) })
          .then(function(r){return r.json();})
          .then(function(){ refreshDrawer(); openDrawer(); })
          .finally(function(){ if(btn) btn.removeAttribute('disabled'); });
      });
    });
    document.querySelectorAll('[data-cart-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); refreshDrawer(); openDrawer(); }); });
    if(drawer){ drawer.addEventListener('click', function(e){ if(e.target===drawer || e.target.hasAttribute('data-cart-close')) closeDrawer(); }); }
  }
  function serialize(form){
    var fd = new FormData(form), o = {};
    fd.forEach(function(v,k){ o[k]=v; });
    return o;
  }

  /* ---- blog / collection load more via Section Rendering API ---- */
  function initLoadMore(){
    document.querySelectorAll('[data-load-more]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var url = btn.getAttribute('data-load-more');
        var target = document.querySelector(btn.getAttribute('data-target'));
        fetch(url).then(function(r){return r.text();}).then(function(html){
          var doc = new DOMParser().parseFromString(html,'text/html');
          var add = doc.querySelector(btn.getAttribute('data-target'));
          if(add && target){ target.insertAdjacentHTML('beforeend', add.innerHTML); }
          var next = doc.querySelector('[data-load-more]');
          if(next){ btn.setAttribute('data-load-more', next.getAttribute('data-load-more')); }
          else { btn.remove(); }
          initReveal();
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    initReveal(); initRotor(); initMenu(); initModals(); initGift(); initQty(); initCart(); initLoadMore();
  });
})();
